import { render, staticRenderFns } from "./SpiderChart.vue?vue&type=template&id=80c7193a&scoped=true"
import script from "./SpiderChart.vue?vue&type=script&lang=js"
export * from "./SpiderChart.vue?vue&type=script&lang=js"
import style0 from "./SpiderChart.vue?vue&type=style&index=0&id=80c7193a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c7193a",
  null
  
)

export default component.exports